import React from 'react';
import { AddIcon, Card, Input } from '@avila-tek/ui/src';
import { Button } from '@avila-tek/ui/src/Button';
import { FormHeader } from '../../shared/Forms';
import { Plan } from '../../../models';
import FrequencyInput from './FrequencyInput';

interface PlanFormContentProps {
  formState?: Partial<Plan>;
  setFormState?: React.Dispatch<React.SetStateAction<Partial<Plan>>>;
}

function PlanFormContent({ formState, setFormState }: PlanFormContentProps) {
  const handleInputChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    e.preventDefault();
    const { value, name } = e.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleAddFrequency = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    const newFrequency = formState?.frequencies;
    newFrequency?.push({
      time: 0,
      price: 0,
    });
    setFormState({
      ...formState,
      frequencies: newFrequency,
    });
  };

  return (
    <Card>
      <FormHeader
        href="/app/maintenance/plans"
        title={formState._id ? 'Actualizar plan' : 'Crear plan'}
        backBtnText="Planes"
      />
      <Card.Body>
        <div className="w-full flex md:flex-row flex-col gap-5 ">
          <div className="w-full">
            <Input
              value={formState?.title ?? ''}
              label="Nombre"
              type="text"
              placeholder="Ingrese un nombre"
              onChange={handleInputChange}
              name="title"
              required
            />
          </div>
          <div className="w-full">
            <Input
              value={formState?.couponPrice}
              label="Precio del cupon preferencial"
              name="couponPrice"
              type="number"
              placeholder="Ingrese el valor de venta de cupon del 5$" // FIXME: Cambiar el valor por el valor de la moneda
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className="w-full flex md:flex-row flex-col gap-5">
          <div className="w-full md:w-1/2 pr-2">
            <Input
              value={formState?.discountCoupons}
              label="Número de puntos a precio preferencial"
              type="number"
              name="discountCoupons"
              placeholder="Ingrese el número de puntos a precio preferencial"
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="w-full md:w-1/2 pr-2">
            <Input
              value={formState.freeCoupons}
              label="Puntos de cortesia mensuales"
              type="number"
              name="freeCoupons"
              placeholder="Ingrese el número de puntos de cortesia mensuales"
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <hr className="mt-3" />
        <div className="flex justify-between">
          <h3 className="text-purple-300 font-semibold text-lg">Frecuencia</h3>
          <div>
            <Button className="flex items-center" onClick={handleAddFrequency}>
              Agregar <AddIcon className="w-5 h-5" />
            </Button>
          </div>
        </div>
        <div>
          {formState?.frequencies?.length > 0 ? (
            formState?.frequencies?.map((frequency, index) => (
              <FrequencyInput
                setFormState={setFormState}
                index={index}
                frequency={frequency}
              />
            ))
          ) : (
            <div className="w-full text-center">
              <p className="text-neutral-300">
                Agregue frecuencias para el plan
              </p>
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default PlanFormContent;
